import React, { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import Form from "~/common/components/Form";
import Input from "~/common/components/Input";
import { CopyIcon, MoveIcon, TrashIcon } from "~/assets/svg/InterfaceIcon";
import { ApplyContext } from "~/pages/applyFormMange/ApplyRegContext";
import { useTranslation } from "react-i18next";

const InquiryText = ({ card, elementRef }) => {
	const { t } = useTranslation();
	const { setListByTarget, handleInquiryCopyFields, handleInquiryDelete } =
		useContext(ApplyContext);
	const inquiryForm = useForm({
		defaultValues: {
			inquiryCategory: card.title,
			inquiryCategoryDesc: card.description,
		},
	});

	const categoryInput = inquiryForm.watch("inquiryCategory");
	const categoryDetailInput = inquiryForm.watch("inquiryCategoryDesc");

	useEffect(() => {
		setListByTarget({
			...card,
			title: categoryInput,
			category: categoryInput,
			description: categoryDetailInput,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [categoryInput, categoryDetailInput]);

	useEffect(() => {
		inquiryForm.reset({ inquiryCategory: card.title, inquiryCategoryDesc: card.description });
	}, [card]);

	return (
		<>
			<button ref={elementRef} type="button" className="btn-inquiry-move">
				<MoveIcon />
			</button>

			<Form useForm={inquiryForm}>
				<Input
					name="inquiryCategory"
					placeholder={t(
						"pages.applyFormMange.inputComponent.applyInquriy.cardType.Category.inquiryCategory"
					)}
					disabled={card.disabled}
				/>
				<Input
					name="inquiryCategoryDesc"
					className="export-label"
					placeholder={t(
						"pages.applyFormMange.inputComponent.applyInquriy.cardType.Category.inquiryCategoryDesc"
					)}
					disabled={card.disabled}
				/>
			</Form>
			<div className="inquiry-setting-bottom">
				<button
					type="button"
					className="btn-copy"
					onClick={() => handleInquiryCopyFields(card.order)}
					disabled={card.disabled}
				>
					<CopyIcon />
				</button>
				<button
					type="button"
					className="btn-trash"
					onClick={() => handleInquiryDelete(card.order)}
					disabled={card.disabled}
				>
					<TrashIcon />
				</button>
			</div>
		</>
	);
};

export default InquiryText;
